module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reports":"Reports","all":"All","rack":"Rack","email":"Email","frequency":"Frequency","add entry":"add entry","daily":"daily","weekly":"weekly","monthly":"monthly"},"de":{"reports":"Reports","all":"Alle","rack":"Rack","email":"Email","frequency":"Wiederholung","add entry":"Eintrag hinzufügen","daily":"täglich","weekly":"wöchentlich","monthly":"monatlich"}}')
  delete Component.options._Ctor
}
